import React from 'react';
import InfoModal from '../../components/common/InfoModal';
import { useTranslation } from 'react-i18next';

export default function UserInfoModal({ isOpen, onClose, user }) {
  const { t } = useTranslation();
  if (!user) return null;

  const formatDate = (date) => {
    if (!date) return t('common.na');
    try {
      return new Date(date).toLocaleString();
    } catch {
      return date;
    }
  };

  return (
    <InfoModal isOpen={isOpen} onClose={onClose} title={t('userDetails.title')}>
      <div className="space-y-2 text-gray-700">
        <p>
          <strong>{t('userDetails.username')}</strong> {user.username || t('common.na')}
        </p>
        <p>
          <strong>{t('userDetails.email')}</strong>{' '}
          {user.email ? (
            <a href={`mailto:${encodeURIComponent(user.email)}`} className="text-blue-600 hover:underline break-all">{user.email}</a>
          ) : (
            t('common.na')
          )}
        </p>
        <p>
          <strong>{t('userDetails.role')}</strong> {user.role ? t('adminUsers.role_' + user.role, { defaultValue: user.role }) : t('common.na')}
        </p>
        <p>
          <strong>{t('userDetails.createdAt')}</strong> {formatDate(user.createdAt)}
        </p>
        <p>
          <strong>{t('userDetails.updatedAt')}</strong> {formatDate(user.updatedAt)}
        </p>
      </div>
    </InfoModal>
  );
}
